import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelModule} from 'primeng/panel';
import {TranslocoPipe} from '@jsverse/transloco';
import {ModuleFunctionStatusBadgeComponent} from '../module-function-status-badge/module-function-status-badge.component';

@Component({
  selector: 'app-system-recording-legend',
  imports: [CommonModule, PanelModule, TranslocoPipe, ModuleFunctionStatusBadgeComponent],
  templateUrl: './system-recording-legend.component.html',
})
export class SystemRecordingLegendComponent {}
